import { PoolRisk } from 'modules/pools/constants/PoolRisk'

export const NFCS_SCORES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
export const NFCS_LOW_RISK = [1, 2, 3]
export const NFCS_MIDDLE_RISK = [4, 5, 6]
export const NFCS_HIGH_RISK = [7, 8, 9, 10]
export const NFCS_FRAUD = 201
export const NFCS_LIQUIDATED = 101
export const NFCS_DEFAULTED = 102

export const getNFCSScoresByPoolRisk = (poolRisk?: PoolRisk) => {
  switch (poolRisk) {
    case PoolRisk.LOW:
      return NFCS_LOW_RISK
    case PoolRisk.MIDDLE:
      return NFCS_MIDDLE_RISK
    case PoolRisk.HIGH:
      return NFCS_HIGH_RISK
    default:
      return NFCS_SCORES
  }
}

export const isFraudNFCSScore = (nfcs: number) => nfcs === NFCS_FRAUD
export const isBadNFCSScore = (nfcs: number) =>
  nfcs === NFCS_LIQUIDATED || nfcs === NFCS_DEFAULTED
